var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkplaceView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 600,
    viewBox: "0 0 1000 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.028 170.508H188.449V253.921H229.028V170.508Z",
    fill: "#E6E5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.247 170.508V102.308L257.208 73.564V276.464",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.063 91.04V102.876",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.063 112.457V123.729",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.063 133.591V145.683",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.717 230.813H309.059",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.826 230.249V127.249L311.806 103.296L334.068 127.249V230.249H289.826Z",
    fill: "#E6E5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.695 183.095V192.488",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.695 213.529V204.136",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.449 326.061V19.462H809.537V329.443",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.974 231.94H766.14V274.774H808.974V231.94Z",
    fill: "#E6E5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.572 326.061H651.219V343.533H827.572V326.061Z",
    fill: "#E6E5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.295 326.061H169.835V343.533H351.295V326.061Z",
    fill: "#E6E5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.693 231.94H651.23V273.957H707.693V231.94Z",
    fill: "#E6E5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.219 273.957H730.633",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.31 240.676H672.582",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.727 240.676H693.999",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.715 84.84L625.427 62.3L766.14 84.84H580.715Z",
    fill: "#E6E5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.155 62.296V205.136",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.208 62.296V205.136",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.155 85.592L641.208 133.686",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.208 85.592L614.155 133.686",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.155 132.746L641.208 180.84",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.208 132.746L614.155 180.84",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.155 180.84L627.822 205.136",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.208 180.84L627.822 205.136",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.018 175.193H729.881V190.597H763.018V175.193Z",
    fill: "#E6E5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.287 77.701V176.989",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.818 133.301V145.137",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.818 154.718V165.99",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.879 83.641C376.402 83.641 381.691 78.3526 381.691 71.829C381.691 65.3054 376.402 60.017 369.879 60.017C363.355 60.017 358.067 65.3054 358.067 71.829C358.067 78.3526 363.355 83.641 369.879 83.641Z",
    fill: "#E9AF34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.733 54.668V39.735",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.502 89.77V103.588",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.69 58.679L390.566 46.644",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.035 57.007L352.343 45.195",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.68 65.142L339.862 60.796",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.011 75.729L338.859 80.855",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.067 85.312L350.003 97.459",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.977 86.761L388.449 98.796",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.777 68.374L401.264 62.969",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.128 78.292L400.038 83.64",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.214 175.572L440.5 175.572",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.629 189.133V117.562H488.343V206.041",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.998 56.392V117.165",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.579 152.716V132.746H530.052V152.716H514.96V205.04H583.676V152.716H568.579Z",
    fill: "#E6E5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.914 493.645L402.435 454.603H570.535L589.514 493.645",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.527 463.821H410.238L395.928 493.645",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.616 473.818H444.46",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.673 483.755H426.836",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.975 463.821L408.671 489.036",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.169 463.985L423.747 477.555",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.726 220.351H384.151C376.879 220.351 370.985 226.246 370.985 233.517V393.177C370.985 400.448 376.879 406.343 384.151 406.343H619.726C626.997 406.343 632.892 400.448 632.892 393.177V233.517C632.892 226.246 626.997 220.351 619.726 220.351Z",
    fill: "#E9AF34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.251 234.449H385.626V384.075H618.251V234.449Z",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.977 402.547C479.977 402.547 484.586 429.538 459.419 438.756H546.132C546.132 438.756 521.067 430.201 522.693 402.547",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.219 368.487H998.542",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.31396 368.487H350.603",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.898 435.3L992.251 533.463L780 533L742.717 520L684.246 435.269L910.898 435.3Z",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.466 450.863L770.626 515.251H949.96L897.501 450.744L722.466 450.863Z",
    fill: "#E9AF34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.228 447.977L862.92 477.3H827.8",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.879 488.128L897.588 521.183",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.512 477.297H802.137",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.921 465.107L193.155 463.407L190.392 471.539L184.159 472.572",
    fill: "#E9AF34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4144 491.255L185.542 476.312L183.103 461.601L92.9753 476.544L95.4144 491.255Z",
    fill: "#E9AF34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.043 487.669L114.604 472.958",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.937 575.479L686.112 499.923L840.112 554.885L721.937 575.479Z",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.701 524.5L731.194 559.3L786.894 549.657L714.701 524.5Z",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.806 574.797L724.765 570.49",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.172 571.011L745.154 566.751",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.57 567.291L765.576 563.078",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788.001 563.637L786.03 559.471",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.466 560.05L806.518 555.931",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.985 572.895L733.196 564.898",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.366 569.142L753.621 561.233",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.782 565.456L774.08 557.634",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.229 561.835L794.571 554.101",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.71 558.282L815.095 550.635",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.963 556.53L827.039 552.458",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.86 294.637L486.476 275.121L535.315 289.738L535.06 307.489L561.76 314.564L562.015 332.193L519.347 351.677L443.86 330.125V294.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.816 330.193L519.483 351.743",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.576 310.796L562.243 332.353",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.816 330.194L486.484 310.703",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.816 312.649L486.484 295.09",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.863 330.124V294.353",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.096 326.484V308.984",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.484 310.703V274.951",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.816 294.422L465.15 284.769",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.145 284.769L486.479 275.121",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.863 312.415L519.364 333.984",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.863 294.637L493.096 308.984",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.475 275.307L535.708 289.659",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.02 314.569L519.364 333.984",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.484 295.09L535.318 307.687",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.096 308.984L535.318 289.738",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.318 289.738V307.688",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.352 333.984V351.676",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.352 351.677L562.02 332.193",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.02 314.569V332.058",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.063 307.489L561.765 314.564",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.096 326.485L535.063 307.489",
    stroke: "#3C3C3C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.048 471.147L232.525 466.947L239.656 455.411L290.304 459.611L284.048 471.147Z",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.16 481.883L223.718 481.126L228.775 472.992L238.106 473.749L233.16 481.883Z",
    fill: "#DB6C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.043 483.073L238.568 482.316L243.45 474.182L252.814 474.939L248.043 483.073Z",
    fill: "#DB6C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.16 484.2L252.654 483.443L257.37 475.309L266.765 476.066L262.16 484.2Z",
    fill: "#DB6C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.32 485.324L266.783 484.567L271.334 476.433L280.76 477.19L276.32 485.324Z",
    fill: "#DB6C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.932 493.736L216.332 492.979L221.41 484.845L230.903 485.602L225.932 493.736Z",
    fill: "#DB6C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.066 494.926L231.429 494.169L236.329 486.035L245.855 486.792L241.066 494.926Z",
    fill: "#DB6C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.423 496.051L245.755 495.294L250.492 487.16L260.049 487.917L255.423 496.051Z",
    fill: "#DB6C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.826 497.177L260.126 496.42L264.698 488.286L274.286 489.043L269.826 497.177Z",
    fill: "#DB6C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.669 505.589L208.902 504.832L214.002 496.698L223.657 497.455L218.669 505.589Z",
    fill: "#DB6C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.06 506.779L224.26 506.022L229.184 497.888L238.872 498.645L234.06 506.779Z",
    fill: "#DB6C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.66 507.9L238.83 507.143L243.588 499.009L253.307 499.766L248.66 507.9Z",
    fill: "#DB6C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.3 509.03L253.439 508.273L258.032 500.139L267.782 500.896L263.3 509.03Z",
    fill: "#DB6C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.16 517.79L201.226 517.033L206.346 508.899L216.168 509.656L211.16 517.79Z",
    fill: "#DB6C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.813 518.98L216.847 518.223L221.792 510.089L231.647 510.846L226.813 518.98Z",
    fill: "#DB6C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.66 520.105L231.66 519.348L236.44 511.214L246.326 511.971L241.66 520.105Z",
    fill: "#DB6C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.551 521.231L246.523 520.474L251.138 512.34L261.055 513.097L256.551 521.231Z",
    fill: "#DB6C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.118 448.911L185.403 523.123L185.109 530.708L260.5 536.956L303.684 462.366L303.994 454.358L234.119 448.911",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.532 452.353C643.532 452.353 628.287 452.353 628.287 469.99V484.465C628.287 484.465 630.112 501.007 643.532 501.007C655.857 501.007 659.425 489.33 659.75 485.438C660.075 481.546 660.277 469.686 660.277 469.686C660.277 469.686 661.615 452.353 643.532 452.353Z",
    fill: "#DB6C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.075 471.572V451.872C644.075 449.043 643.361 445.772 640.663 444.306C636.837 442.227 631.825 443.651 627.732 443.883C622.886 444.157 617.568 444.472 612.982 442.594C608.175 440.626 605.495 436.154 604.882 431.113C604.451 427.576 604.442 423.319 606.782 420.378C608.188 418.612 610.758 417.122 613.051 417.86C614.042 418.165 614.889 418.82 615.434 419.703C615.978 420.586 616.182 421.637 616.009 422.66C615.365 425.876 612.288 430.619 600.826 432.088C588.199 433.707 580.391 428.034 580.391 428.034C580.391 428.034 566.444 417.979 569.201 402.247",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.587 471.572H663.593",
    stroke: "#1F323D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 600,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkplaceView);
export default __webpack_public_path__ + "static/media/workplace_view.71567534339587ae6c1f79e2d4b27c5e.svg";
export { ForwardRef as ReactComponent };